const API_BASE = import.meta.env.VITE_API_URL || 'https://api.retro.kf-mau.ru';

export const galleryApi = {
  // 1. Загрузка фото (с поддержкой массива тегов)
  uploadPhotos: async (files, metadata, token) => {
    const formData = new FormData();

    // Добавляем файлы
    files.forEach(file => formData.append('photos', file));

    // Добавляем метаданные
    Object.entries(metadata).forEach(([key, value]) => {
      if (value !== undefined && value !== null && value !== '') {
        if (Array.isArray(value)) {
          // Массивы отправляем как tags[]=1&tags[]=2&tags[]=3
          value.forEach(v => formData.append(`${key}[]`, v));
        } else {
          formData.append(key, value);
        }
      }
    });

    console.log('📤 Отправка на сервер:');
    console.log('  Файлов:', files.length);
    console.log('  Метаданные:', metadata);

    const res = await fetch(`${API_BASE}/api/upload-photos/`, {
      method: 'POST',
      headers: {
        'Authorization': `Bearer ${token}`
      },
      body: formData
    });

    const data = await res.json();
    if (!res.ok) throw new Error(data.error || 'Ошибка загрузки');
    return data;
  },

  // 2. Получить типы контента
  getContentTypes: async () => {
    const res = await fetch(`${API_BASE}/api/types/`);
    if (!res.ok) throw new Error(`HTTP ${res.status}`);
    const data = await res.json();
    return Array.isArray(data) ? data : (data.types || []);
  },

  // 3. Получить теги
  getTags: async () => {
    const res = await fetch(`${API_BASE}/api/tags/`);
    if (!res.ok) throw new Error(`HTTP ${res.status}`);
    const data = await res.json();
    return Array.isArray(data) ? data : (data.tags || []);
  },

  // 4. Поиск с фильтрами
  search: async (params) => {
  const qs = new URLSearchParams();
  if (params.query) qs.append('query', params.query);
  if (params.dateFrom) qs.append('dateFrom', params.dateFrom);
  if (params.dateTo) qs.append('dateTo', params.dateTo);
  
  // Теги
  const tags = params.tags || params.tagIds || [];
  if (tags && tags.length > 0) {
    tags.forEach(id => qs.append('tags[]', String(id)));
  }
  
  // Типы — массивом (types[]=Фотография&types[]=Фотоальбом)
  const types = params.types || (params.type ? [params.type] : []);
  if (types && types.length > 0) {
    types.forEach(t => qs.append('types[]', t));
  }

  const url = `${API_BASE}/api/search/?${qs.toString()}`;
  console.log(' Search URL:', url);

  const response = await fetch(url);
  if (!response.ok) throw new Error(`Search failed: ${response.status}`);
  return await response.json();
},

  // 5. Получить все фото для галереи
  getPhotos: async () => {
    const res = await fetch(`${API_BASE}/api/gallery/`);
    if (!res.ok) throw new Error(`HTTP ${res.status}`);
    return await res.json();
  },

  // 6. Редактирование фото
  updatePhoto: async (photoId, data, token) => {
    const res = await fetch(`${API_BASE}/api/photo/${photoId}/update/`, {
      method: 'PATCH',
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(data)
    });
    if (!res.ok) throw new Error(await res.text());
    return await res.json();
  },

  // 7. Редактирование альбома (с поддержкой массива тегов)
  updateAlbum: async (albumId, data, token) => {
    const res = await fetch(`${API_BASE}/api/album/${albumId}/update/`, {
      method: 'PATCH',
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(data)
    });
    if (!res.ok) throw new Error(await res.text());
    return await res.json();
  },

  // 8. Получить детали альбома
  getAlbum: async (albumId, token) => {
    const headers = token ? { 'Authorization': `Bearer ${token}` } : {};
    const res = await fetch(`${API_BASE}/api/album/${albumId}/`, { headers });
    if (!res.ok) throw new Error(`HTTP ${res.status}`);
    return await res.json();
  },

  // 9. Удалить альбом
  deleteAlbum: async (albumId, token) => {
  const res = await fetch(`${API_BASE}/api/album/${albumId}/delete/`, {  
    method: 'DELETE',
    headers: { 'Authorization': `Bearer ${token}` }
  });
  if (!res.ok) {
    const error = await res.json().catch(() => ({}));
    throw new Error(error.error || `HTTP ${res.status}`);
  }
  return await res.json();
},

  // 10. Удалить фото
  deletePhoto: async (photoId, token) => {
    const res = await fetch(`${API_BASE}/api/photo/${photoId}/delete/`, {
      method: 'DELETE',
      headers: { 'Authorization': `Bearer ${token}` }
    });
    if (!res.ok) throw new Error(`HTTP ${res.status}`);
    return await res.json();
  },

  // 11. Получить комментарии к фото
  getComments: async (photoId) => {
    const res = await fetch(`${API_BASE}/api/photo/${photoId}/comments/`);
    if (!res.ok) throw new Error('Failed to load comments');
    return await res.json();
  },

  // 12. Создать комментарий
  createComment: async (photoId, description, suggestedTitle, suggestedDate, token) => {
    const res = await fetch(`${API_BASE}/api/photo/${photoId}/comment/`, {
      method: 'POST',
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        description,
        suggested_title: suggestedTitle,
        suggested_date: suggestedDate
      })
    });
    if (!res.ok) throw new Error(await res.text());
    return await res.json();
  },

  // 13. Редактировать комментарий
  updateComment: async (commentId, description, token) => {
    const res = await fetch(`${API_BASE}/api/comment/${commentId}/`, {
      method: 'PATCH',
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({ description })
    });
    if (!res.ok) throw new Error(await res.text());
    return await res.json();
  },

  // 14. Удалить комментарий
  deleteComment: async (commentId, token) => {
    const res = await fetch(`${API_BASE}/api/comment/${commentId}/delete/`, {
      method: 'DELETE',
      headers: { 'Authorization': `Bearer ${token}` }
    });
    if (!res.ok) throw new Error(await res.text());
    return await res.json();
  },

  // 15. Модерация комментария
  moderateComment: async (commentId, approved, token) => {
    const res = await fetch(`${API_BASE}/api/comment/${commentId}/moderate/`, {
      method: 'PATCH',
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({ approved })
    });
    if (!res.ok) throw new Error(await res.text());
    return await res.json();
  },

  // 16. Получить детали фото
  getPhotoDetails: async (photoId, token) => {
    const headers = token ? { 'Authorization': `Bearer ${token}` } : {};
    const res = await fetch(`${API_BASE}/api/photo/${photoId}/`, { headers });
    if (!res.ok) throw new Error(`HTTP ${res.status}`);
    return await res.json();
  },
};